export enum CaseWeightUom {
  LBS = 'LBS',
  KG = 'KG'
}
